module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "bg-full",
    staticStyle: {
      "background-image": "url(/static/images/img13.jpg)"
    },
    attrs: {
      "id": "footer"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('p', [_vm._v(_vm._s(_vm.date) + " © P. Pedersen & Søn\n                          |  \n                        CVR: 60098018\n                          |  \n                        Udviklet af "), _c('a', {
    staticClass: "brand-link",
    attrs: {
      "href": "https://deveo.dk",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Deveo")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-holder container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-12"
  }, [_c('h3', [_vm._v("Kontakt os")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-12"
  }, [_c('ul', {
    staticClass: "list-unstyled contactlist"
  }, [_c('li', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('i', {
    staticClass: "icon fal fa-phone"
  }), _vm._v(" "), _c('span', {
    staticClass: "tel"
  }, [_c('a', {
    attrs: {
      "href": "tel:+4540436078"
    }
  }, [_vm._v("40 43 60 78")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-12"
  }, [_c('ul', {
    staticClass: "list-unstyled contactlist"
  }, [_c('li', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('i', {
    staticClass: "icon fal fa-envelope"
  }), _vm._v(" "), _c('span', {
    staticClass: "mail"
  }, [_c('a', {
    attrs: {
      "href": "mailto:karsten@p-pedersen.dk"
    }
  }, [_vm._v("karsten@p-pedersen.dk")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 col-md-6 col-sm-12"
  }, [_c('ul', {
    staticClass: "list-unstyled contactlist"
  }, [_c('li', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('i', {
    staticClass: "icon fal fa-home"
  }), _vm._v(" "), _c('address', [_vm._v("Nørrebro 23, 5985 Søby Ærø")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ebecd11"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/footer.vue
// module id = 264
// module chunks = 1